import { render, staticRenderFns } from "./projectOEM.vue?vue&type=template&id=b2c2b9d0&"
import script from "./projectOEM.vue?vue&type=script&lang=ts&"
export * from "./projectOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports